<template>
  <div>
    <v-client-table
      :data="tableItems"
      :columns="table.columns"
      :options="table.options"
      class="table-default"
      :class="{ 'table-default--loading': tablePreloader }"
    >
      <template #h__legal_entity><div class="table-default__left">Legal entity</div></template>
      <template #h__standard_rated_sales_net>Sales<br>NET</template>
      <template #h__standard_rated_sales_vat>Sales<br>VAT</template>
      <template #h__exempt_sales_local>Sales<br>Exempt</template>
      <template #h__standard_rated_purchases_local_net>Purchases<br>Local NET</template>
      <template #h__standard_rated_purchases_local_vat>Purchases<br>Local VAT</template>
      <template #h__standard_rated_purchases_import_net>Purchases<br>Import NET</template>
      <template #h__standard_rated_purchases_import_vat>Purchases<br>Import VAT</template>
      <template #h__exempt_purchases_local>Purchases<br>Exempt</template>
      <template #h__non_creditable_purchases_local>Purchases<br>Non Creditable</template>
      <template #h__vat_output>VAT<br>Output</template>
      <template #h__vat_input>VAT<br>Input</template>
      <template #legal_entity="{ row }">
        <router-link :to="{name: 'finance-taxes-vat-statement-detail', params: {id: row.id }}" class="table-default__link-border">
          {{ row.legal_entity.name }} ({{ dateFormatMonth(row.from_date) }})
        </router-link>
      </template>
      <template #standard_rated_sales_net="{ row }">{{ amountFormat(row.standard_rated_sales_net) }}</template>
      <template #standard_rated_sales_vat="{ row }">{{ amountFormat(row.standard_rated_sales_vat) }}</template>
      <template #exempt_sales_local="{ row }">{{ amountFormat(row.exempt_sales_local) }}</template>
      <template #standard_rated_purchases_local_net="{ row }">{{ amountFormat(row.standard_rated_purchases_local_net) }}</template>
      <template #standard_rated_purchases_local_vat="{ row }">{{ amountFormat(row.standard_rated_purchases_local_vat) }}</template>
      <template #standard_rated_purchases_import_net="{ row }">{{ amountFormat(row.standard_rated_purchases_import_net) }}</template>
      <template #standard_rated_purchases_import_vat="{ row }">{{ amountFormat(row.standard_rated_purchases_import_vat) }}</template>
      <template #exempt_purchases_local="{ row }">{{ amountFormat(row.exempt_purchases_local) }}</template>
      <template #non_creditable_purchases_local="{ row }">{{ amountFormat(row.non_creditable_purchases_local) }}</template>
      <template #vat_output="{ row }">{{ amountFormat(row.vat_output) }}</template>
      <template #vat_input="{ row }">{{ amountFormat(row.vat_input) }}</template>
    </v-client-table>
    <app-cells position="between">
      <div>
        <paginate
          @input="$emit('clickPagination', $event)"
          v-if="pagination.pages > 1"
          v-model="pagination.page"
          :page-count="pagination.pages"
          :prev-text="'<'"
          :next-text="'>'"
          :container-class="'pagination'"
          :page-class="'pagination__item'"
          :page-link-class="'pagination__link'"
          :prev-class="'pagination__item pagination__item--prev'"
          :next-class="'pagination__item pagination__item--next'"
          :next-link-class="'pagination__link pagination__link--next'"
          :prev-link-class="'pagination__link pagination__link--prev'"
        />
      </div>
      <app-table-records :all="pagination.count" :count="tableItems.length" :page="pagination.page" />
    </app-cells>
  </div>
</template>

<script>
export default {
  name: 'TableListVatCompleted',
  props: ['tableItems', 'tablePreloader', 'pagination', 'dateFormatMonth', 'amountFormat'],
  data() {
    return {
      table: {
        columns: [
          'legal_entity',
          'standard_rated_sales_net',
          'standard_rated_sales_vat',
          'exempt_sales_local',
          'standard_rated_purchases_local_net',
          'standard_rated_purchases_local_vat',
          'standard_rated_purchases_import_net',
          'standard_rated_purchases_import_vat',
          'exempt_purchases_local',
          'non_creditable_purchases_local',
          'vat_output',
          'vat_input',
        ],
        options: {
          headings: {
            'legal_entity': 'Legal entity',
            'standard_rated_sales_net': 'Sales (NET)',
            'standard_rated_sales_vat': 'Sales (VAT)',
            'exempt_sales_local': 'Sales (Exempt)',
            'standard_rated_purchases_local_net': 'Purchases (Local NET)',
            'standard_rated_purchases_local_vat': 'Purchases (Local VAT)',
            'standard_rated_purchases_import_net': 'Purchases (Import NET)',
            'standard_rated_purchases_import_vat': 'Purchases (Import VAT)',
            'exempt_purchases_local': 'Purchases (Exempt)',
            'non_creditable_purchases_local': 'Purchases (Non Creditable)',
            'vat_output': 'VAT (Output)',
            'vat_input': 'VAT (Input)',
          },
          pagination: { show: false },
          sortable: [],
          perPage: 20,
          texts: {
            noResults: 'No matching entries',
          },
          rowClassCallback: () => 'table-default__row',
          resizableColumns: false
        },
      },
    }
  },
}
</script>

